<template>
  <div class="per-item">
    <div class="image-wrap" v-if="itemsContains(prod.image)">
      <img :src="prod.image" :alt="prod.name" />
    </div>
    <div class="image-wrap" v-else>
      <img
        class="list-complete-img"
        src="../../../assets/images/default-img.jpg"
        :alt="prod.name"
      />
    </div>
    <div class="text-content">
      <div class="combo" v-if="typeCheck(prod.item_type)">
        <div class="type">{{ type }}</div>
        <div class="title">{{ titleStr(prod.name) }}</div>
        <div class="description">{{ descStr(prod.name) }}</div>
      </div>
      <div class="exclusive" v-else>
        <div class="type">{{ type }}</div>
        <div class="title">{{ prod.name }}</div>
      </div>
    </div>
    <div class="price">NRs.{{ prod.after_price }}</div>
  </div>
</template>

<script>
import { CartData } from "../../../services/storage.service";
import { mapGetters, mapActions } from "vuex";
import isEmpty from "../../../utils/isEmpty";
import isUrl from "../../../utils/isUrl";
export default {
  name: "Item",
  props: ["prod", "type"],
  data() {
    return {
      add: false,
      quantity: 1,
      itemId: null,
    };
  },
  created() {
    this.itemId = this.prod.id;
    if (this.cartItems.filter((food) => food.id === this.prod.id).length > 0) {
      this.add = true;
    }
  },
  watch: {
    // whenever question changes, this function will run
    cartItems: function(newCartItems, oldCartItems) {
      CartData.setCartItems(newCartItems);
      if (newCartItems.length === 0) {
        (this.add = false), (this.quantity = 1);
        return;
      } else if (
        newCartItems.filter((food) => food.id === this.itemId).length === 0
      ) {
        (this.add = false), (this.quantity = 1);
        return;
      } else {
        this.quantity = newCartItems.filter(
          (food) => food.id === this.itemId
        )[0].quantity;
      }
    },
  },
  computed: {
    ...mapGetters(["cartItems"]),
  },
  methods: {
    ...mapActions(["addToCart", "addQuantity", "minusQuantity", "deleteItem"]),
    addToCartCall(item) {
      this.add = !this.add;
      this.addToCart(item);
    },
    increaseQuantity(id) {
      this.addQuantity(id);
    },
    decreaseQuantity(id) {
      if (this.quantity === 1) {
        this.add = false;
        this.deleteItem(id);
      } else {
        this.minusQuantity(id);
      }
    },
    itemsContains(n) {
      if (n.includes("http")) {
        return true;
      } else {
        return false;
      }
    },
    typeCheck(type) {
      if (type === "combo") {
        return true;
      } else {
        return false;
      }
    },
    titleStr(str) {
      var strs = str.split("(", 2);
      return strs[0];
    },
    descStr(str) {
      var strs = str.split("(", 2);
      return strs[1];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.per-item {
  .image-wrap {
    width: 100%;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    &::before {
      content: "";
      z-index: 1;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.5);
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .text-content {
    position: absolute;
    z-index: 1;
    bottom: 40px;
    left: 20px;
    max-width: 90%;
    .type {
      font-size: 18px;
      font-family: $main-font;
      color: $brand-color;
      text-transform: capitalize;
      font-weight: 700;
      transform: translateY(100px);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .title {
      font-size: 22px;
      line-height: 30px;
      font-family: $main-font;
      margin: 10px 0 15px;
      color: #ffffff;
      font-weight: 500;
      transform: translateY(100px);
      transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .description {
      font-size: 14px;
      font-family: $main-font;
      color: #ffffff;
      letter-spacing: 1px;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      height: 65px;
      opacity: 0;
      transform: translateY(90px);
      transition: all 0.9s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .exclusive {
      .type {
        transform: translateY(35px);
      }
      .title {
        transform: translateY(35px);
      }
    }
  }
  .price {
    position: absolute;
    z-index: 2;
    top: 20px;
    overflow: hidden;
    right: 0px;
    background: $brand-color;
    border-radius: 5px 0 0 5px;
    display: flex;
    padding: 0 30px 0 15px;
    align-items: center;
    justify-content: space-between;
    font-family: $main-font;
    font-size: 14px;
    line-height: 40px;
    color: #fff;
    transform: translateX(100%);
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }
  &:hover {
    .text-content {
      .type {
        transform: translateY(0);
      }
      .title {
        color: #fff;
        transform: translateY(0);
      }
      .description {
        opacity: 1;
        transform: translateY(0);
        color: #fff;
      }
      .exclusive {
        .type {
          transform: translateY(35px);
        }
        .title {
          transform: translateY(35px);
        }
      }
    }
    .price {
      transform: translateX(0);
    }
  }
}
</style>
